import get from 'lodash/get';

import { filterProposals } from 'common/api/v1/proposals';

import {
    FETCH_PROPOSALS,
    FETCH_PROPOSALS_FAILURE,
    FETCH_PROPOSALS_SUCCESS,
    SHOW_EMPTY_STATE,
} from '../actionTypes';
import { proposalsActions } from '../reducer';

export default ({ projectId, status } = {}) =>
    (dispatch) => {
        dispatch(proposalsActions[FETCH_PROPOSALS]());

        filterProposals({
            projectId,
            status,
        })
            .then((response) => {
                dispatch(
                    proposalsActions[FETCH_PROPOSALS_SUCCESS](
                        response.data.data,
                    ),
                );
                dispatch(
                    proposalsActions[SHOW_EMPTY_STATE]({
                        status,
                        show: response?.data?.data?.length === 0 || false,
                    }),
                );
            })
            .catch((error) =>
                dispatch(
                    proposalsActions[FETCH_PROPOSALS_FAILURE](
                        get(error, 'data.errors', []),
                    ),
                ),
            );
    };
